import { ChevronLeft, ChevronRight } from 'lucide-react'

import { BLOG_ACTIVE_PILL } from '@/features/blog/constants/blog.constants'
import { Button } from '@/shared/components/ui/Button'
import { cn } from '@/shared/lib/utils'

const iconBtn =
  'size-9 rounded-lg border-neutral-300 bg-white text-neutral-800 shadow-none hover:bg-neutral-50 disabled:opacity-40'

export function BlogPagination({
  currentPage,
  totalPages,
  onPageChange,
  className,
}: {
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  className?: string
}) {
  if (totalPages <= 1) return null

  return (
    <nav className={cn('flex items-center justify-center gap-2', className)} aria-label="Blog pagination">
      <Button
        type="button"
        variant="outline"
        size="icon"
        className={iconBtn}
        disabled={currentPage <= 1}
        onClick={() => onPageChange(currentPage - 1)}
        aria-label="Previous page"
      >
        <ChevronLeft className="size-4" />
      </Button>

      {Array.from({ length: totalPages }, (_, i) => i + 1).map((n) => {
        const active = n === currentPage
        return (
          <Button
            key={n}
            type="button"
            variant={active ? 'default' : 'outline'}
            className={cn(
              'min-w-9 rounded-lg px-3 shadow-none',
              active ? BLOG_ACTIVE_PILL : 'border-neutral-300 bg-white text-neutral-800 hover:bg-neutral-50',
            )}
            onClick={() => onPageChange(n)}
            aria-current={active ? 'page' : undefined}
          >
            {n}
          </Button>
        )
      })}

      <Button
        type="button"
        variant="outline"
        size="icon"
        className={iconBtn}
        disabled={currentPage >= totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        aria-label="Next page"
      >
        <ChevronRight className="size-4" />
      </Button>
    </nav>
  )
}
